import { useUserLanguage } from "@/customHooks";
import styled, { keyframes } from "styled-components";

interface LoadingSpinnerProps {
  sm?: boolean,
  text?: boolean,
  color?: string,
}

const textsData = {
  en: 'Loading',
  es: 'Cargando'
}

const waveAnimation = keyframes`
  0% {
    transform: scaleY(0.1);
  }
  50% {
    transform: scaleY(1);
  }
  100% {
    transform: scaleY(0.1);
  }
`;

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const SpinnerContainer = styled.div<{ $sm: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${({ $sm }) => $sm ? '18px' : '50px'};
  box-sizing: border-box;
`;

const Bar = styled.div<{ $delay: number, $sm: boolean, $color?: string }>`
  width: 4px;
  height: ${({ $sm }) => $sm ? '16px' : '30px'};
  background-color: ${({ theme, $color }) => $color ? $color : theme.colors.primary1};
  margin: 0 2px;
  animation: ${waveAnimation} 1s infinite;
  animation-delay: ${props => props.$delay}s;
`;

export const LoadingSpinner = ({ sm = false, text = false, color }: LoadingSpinnerProps) => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  const bars = Array.from({ length: sm ? 4 : 8 }, (_, i) => i);


  return (
    <MainContainer>
      <SpinnerContainer $sm={sm}>
        {bars.map((_, index) => (
          <Bar
            key={index}
            $delay={index * 0.1}
            $sm={sm}
            $color={color}
            style={{
              height: sm ? '20px' : '30px',
              width: sm ? '3px' : '4px',
            }}
          />
        ))}
      </SpinnerContainer>
      {text && <span>{texts}</span>}
    </MainContainer>
  );
};
